export const learnTypes = {
    loading: "LOADING_LEARN",
    delete: "DELETE_LEARN",
    loadedOne: "LOADED_LEARN",
    loadedMultiple: "LOADED_LEARNS",
    success: "SUCCESS_LEARN",
    restore: "RESTORE_LEARN",
    hardDelete: "HARDDELETE_LEARN",
};
